import script from "./TicketPricing.vue?vue&type=script&setup=true&lang=js"
export * from "./TicketPricing.vue?vue&type=script&setup=true&lang=js"

import "./TicketPricing.vue?vue&type=style&index=0&id=334aa82e&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-334aa82e"]])

export default __exports__